import React, { useState } from 'react';
import { Container, Navbar, Nav, Modal } from 'react-bootstrap';
import { NavLink, useLocation } from 'react-router-dom';
import QuickBookingForm from '../../QuickBookingForm/QuickBookingForm';
import HotelBookingForm from '../../HotelBookingForm/HotelBookingForm';
import './header.css';

const Header = () => {
  const [open, setOpen] = useState(false);
  const [showBookingModal, setShowBookingModal] = useState(false);
  const [showHotelModal, setShowHotelModal] = useState(false);
  const location = useLocation();

  const toggleMenu = () => setOpen(!open);

  const handleAboutClick = (e) => {
    if (location.pathname !== '/') {
      return; // Let the default navigation happen
    }
    
    e.preventDefault();
    const aboutSection = document.querySelector('.banner-description');
    if (aboutSection) {
      aboutSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleToursClick = (e) => {
    if (location.pathname !== '/') {
      return; // Let the default navigation happen
    }
    
    e.preventDefault();
    const packagesSection = document.getElementById('packages-section');
    if (packagesSection) {
      packagesSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleSafariClick = (e) => {
    if (location.pathname !== '/') {
      return; // Let the default navigation happen
    }
    
    e.preventDefault();
    const safariSection = document.querySelector('.safari-section');
    if (safariSection) {
      safariSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      <div className="top-bar">
        <Container>
          <div className="top-bar-content">
            <div className="follow-us">
              FOLLOW US : 
              <a href="https://www.facebook.com/profile.php?id=61575604496984" target="_blank" rel="noopener noreferrer">
                <i className="bi bi-facebook"></i>
              </a>
              <a href="https://www.instagram.com/corbett_aura/" target="_blank" rel="noopener noreferrer">
                <i className="bi bi-instagram"></i>
              </a>
            </div>
            <div className="contact-info">
              <a href="tel:+918979411128">
                <i className="bi bi-telephone"></i> +91 8979411128
              </a>
              <a href="mailto:corbettaura15@gmail.com">
                <i className="bi bi-envelope"></i> corbettaura15@gmail.com
              </a>
            </div>
          </div>
        </Container>
      </div>

      <header className="header-section">
        <div className="main-navbar">
          <Container>
            <Navbar expand="lg" className="p-0">
              <Navbar.Brand as={NavLink} to="/" className="logo-brand">
                Corbett Aura
              </Navbar.Brand>

              <Navbar.Toggle 
                aria-controls="basic-navbar-nav" 
                onClick={toggleMenu}
                className="toggle-btn"
              >
                <i className={open ? "bi bi-x-lg" : "bi bi-list"}></i>
              </Navbar.Toggle>

              <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="mx-auto">
                  <NavLink className="nav-link" to="/">HOME</NavLink>
                  <NavLink className="nav-link" to="/" onClick={handleAboutClick}>ABOUT US</NavLink>
                  <NavLink className="nav-link" to="/" onClick={handleToursClick}>PACKAGES</NavLink>
                  <NavLink className="nav-link" to="/" onClick={handleSafariClick}>SAFARI</NavLink>
                  <NavLink className="nav-link" onClick={() => setShowHotelModal(true)} style={{cursor: 'pointer'}}>HOTELS</NavLink>
                  <NavLink className="nav-link" to="/contact">CONTACT</NavLink>
                </Nav>
                <button 
                  className="book-now-btn" 
                  onClick={() => setShowBookingModal(true)}
                >
                  Book Now
                </button>
              </Navbar.Collapse>
            </Navbar>
          </Container>
        </div>

        {/* Quick Booking Modal */}
        <Modal 
          show={showBookingModal} 
          onHide={() => setShowBookingModal(false)}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>Quick Booking</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <QuickBookingForm onClose={() => setShowBookingModal(false)} />
          </Modal.Body>
        </Modal>

        {/* Hotel Booking Modal */}
        <Modal 
          show={showHotelModal} 
          onHide={() => setShowHotelModal(false)}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>Hotel Booking</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <HotelBookingForm />
          </Modal.Body>
        </Modal>
      </header>
    </>
  );
};

export default Header;
